let normTable = [{
  label: "序号",
  prop: "normId",
  sortable: 1
},
{
  label: "指标名称",
  prop: "normName"
},
{
  label: "指标内容",
  prop: "normDetail"
},
{
  label: "指标等级",
  prop: "level"
},
{
  label: "评价标准",
  prop: "evaCriterion"
},
{
  label: "标准分值",
  prop: "normScore"
},
{
  label: "指标类型",
  prop: "normType"
},
]

let tableColumns2 = [{
  label: "序号",
  prop: "id",
  sortable: 1
},
{
  label: "下发指标数",
  prop: "num"
},
{
  label: "应用周期",
  prop: "period"
},
{
  label: "应用业务模块",
  prop: "module"
},
{
  label: "应用对象",
  prop: "object"
},
{
  label: "应用人群",
  prop: "role"
},
{
  label: "操作人",
  prop: "operation"
},
{
  label: "处理状态",
  prop: "state"
},
]

let normItems = [{
  normId: 1000,
  normName: "共性指标",
  normDetail: "",
  evaCriterion: "",
  normScore: 100,
  normType: "",
  level: 1,
  children: [
    {
      normId: 1010,
      normName: "政治标准",
      normDetail: "",
      evaCriterion: "",
      normScore: 36,
      normType: "",
      level: 2,
      children: [{
        normId: 1011,
        normName: "政治忠诚",
        normDetail: "1.对党忠诚，理想信念坚定，能做到听党指挥、为党尽责、干事创业（4分）；2.把党放在心中最高位置，坚持党对一切工作的领导，始终坚定正确政治方向，牢牢站稳政治立场（3分）；",
        evaCriterion: "",
        normScore: 12,
        normType: "",
        level: 3,
      },
      {
        normId: 1012,
        normName: "政治定力",
        normDetail: "1.坚决维护习近平总书记在党中央和全党的核心地位，坚决维护党中央权威和集中统一领导（4分）；",
        evaCriterion: "",
        normScore: 12,
        normType: "",
        level: 3,
      },
      ]
    },
  ]
},
]

export {
  normTable,
  normItems,
  tableColumns2,
}